import shuffle from "lodash-es/shuffle";

export class NonRepeatingShuffledArray<TElement> {
    private initialArray: TElement[] = [];
    private remainingRandomElements: TElement[] = [];

    constructor(array: TElement[]) {
        this.initialArray = array;
        this.remainingRandomElements = shuffle(array);
    }

    private GetElement() {
        const shouldReload = this.remainingRandomElements.length === 0;

        if (shouldReload) {
            this.remainingRandomElements = shuffle(this.initialArray);
        }

        const randomElement = this.remainingRandomElements[0];
        this.remainingRandomElements = this.remainingRandomElements.slice(1);
        return randomElement;
    }

    public Take(numberOfItems: number): TElement[] {
        var shuffledItems: TElement[] = [];

        for (let index = 0; index < numberOfItems; index++) {
            var item = this.GetElement();
            shuffledItems.push(item);
        }

        return shuffledItems;
    }

    public TakeOne(): TElement {
        return this.Take(1)[0];
    }
}
